import { memo, useEffect, VFC } from 'react'
import { useLocation } from 'react-router'

const ScrollToTop: VFC = () => {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

export default memo(ScrollToTop)
